import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ITableServerResponseFilter } from 'src/app/common/interfaces/table/table-server-filter-response.interface';
import { ITableServerFilter } from 'src/app/common/interfaces/table/table-server-filter.inteface';
import { AbstractRtpAccountActivityRespondentService } from '../abstraction/abstract.account-activity-respondent.service';
import { IRtpNetActivityStatus } from '../../interfaces/account-activity/net-activity-status';

@Injectable({
  providedIn: 'root',
})
export class AccountRtpActivityRespondentService extends AbstractRtpAccountActivityRespondentService {
  controllerRespondent = `/manager/rtp/rtpaccountactivityrespondent`;

  urlGetAccountActivityRespondentGrid = `${environment.apiUrl}${this.controllerRespondent}/grid`;
  urlGetAccountActivityRespondentExportExcel = `${environment.apiUrl}${this.controllerRespondent}/gridExportExcel`;
  urlGetAccountActivityRespondentExportCSV = `${environment.apiUrl}${this.controllerRespondent}/gridExportCSV`;
  urlGetCurrentAccountActivityRespondent = `${environment.apiUrl}${this.controllerRespondent}/getcurrentnetactivityrespondent`;

  constructor(private http: HttpClient) {
    super();
  }

  override tableFilter(
    filter: ITableServerFilter
  ): Promise<ITableServerResponseFilter | undefined> {
    return this.http
      .post<ITableServerResponseFilter>(`${this.urlGetAccountActivityRespondentGrid}`, filter)
      .toPromise();
  }

  override tableExportCSV(filter: ITableServerFilter): Promise<Blob | undefined> {
    return this.http
      .post(`${this.urlGetAccountActivityRespondentExportCSV}`, filter, {
        responseType: 'blob',
      })
      .toPromise();
  }
  override tableExportExcel(filter: ITableServerFilter): Promise<any> {
    return this.http.post(`${this.urlGetAccountActivityRespondentExportExcel}`, filter).toPromise();
  }

  override getCurrentActivity(): Promise<string | undefined> {
    return this.http.get<string>(`${this.urlGetCurrentAccountActivityRespondent}`).toPromise();
  }
}
